import { atom } from 'recoil';

interface TemplateGalleryModalState {
    isOpen: boolean;
    isVisuallyOpen: boolean;
}

export const templateGalleryState = atom<TemplateGalleryModalState>({
    key: 'templateGalleryState',
    default: {
        isOpen: false,
        isVisuallyOpen: false,
    },
});
